import root from 'window-or-global';
import throttle from 'lodash.throttle';
import {Ref, useEffect, useRef, useState} from 'react';

export type UseWidth = [Ref<HTMLElement>, number];

const useWidth = (): UseWidth => {
    const [width, setWidth] = useState(0);
    const container = useRef(null);
    const containerCurrent = container.current;

    const getWidth = () => (containerCurrent ? containerCurrent.getBoundingClientRect().width : 0);

    useEffect(() => {
        setWidth(getWidth);

        const handler = throttle(() => {
            setWidth(getWidth);
        }, 500);

        root.addEventListener('resize', handler);

        return () => {
            root.removeEventListener('resize', handler);
        };
    }, [containerCurrent]);

    return [container, width];
};

export default useWidth;
